// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyC7fYkJQO_UlaqBbFL6p74EzrAyDoxTwK8",
    authDomain: "ogdry-synerge.firebaseapp.com",
    databaseURL: "https://ogdry-synerge.firebaseio.com",
    projectId: "ogdry-synerge",
    storageBucket: "",
    messagingSenderId: "109396340110",
    appId: "1:109396340110:web:975797a8e991b855b248df"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
